import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'lv',
  months: [
    'janvāris',
    'februāris',
    'marts',
    'aprīlis',
    'maijs',
    'jūnijs',
    'jūlijs',
    'augusts',
    'septembris',
    'oktobris',
    'novembris',
    'decembris',
  ],
  monthsShort: ['janv.', 'febr.', 'marts', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
  weekdays: ['svētdiena', 'pirmdiena', 'otrdiena', 'trešdiena', 'ceturtdiena', 'piektdiena', 'sestdiena'],
  weekdaysMin: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
  weekdaysShort: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
  formats: {
    LT: 'H.mm',
    LTS: 'H:mm:ss',
    lt: 'H.mm',
    lts: 'H:mm:ss',
    L: 'DD.MM.YYYY.',
    LL: 'D. MMMM, YYYY',
    'LL-D': 'MMMM, YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM, YYYY, H.mm',
    'LLL-Y': 'D. MMMM, H.mm',
    LLLL: 'dddd, D. MMMM, YYYY, H.mm',
    'LLLL-Y': 'dddd, D. MMMM, H.mm',
    l: 'D.MM.YYYY.',
    'l-Y': 'D.MM.',
    ll: 'D. MMM., YYYY',
    'll-Y': 'D. MMM.',
    lll: 'D. MMM., YYYY, H.mm',
    'lll-Y': 'D. MMM., H.mm',
    llll: 'ddd., D. MMM., YYYY, H.mm',
    'llll-Y': 'ddd., D. MMM., H.mm',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': '([GMT]Z) (HH:mm)',
    'LLL+to': '([GMT]Z) (YYYY. [gada] D. MMMM HH:mm)',
  },
  meridiem: { am: 'priekšp.', pm: 'pēcp.', AM: 'priekšp.', PM: 'pēcp.' },
  past: {
    y: { zero: 'pirms %s g.', one: 'pirms %s g.', other: 'pirms %s g.' },
    M: { zero: 'pirms %s mēn.', one: 'pirms %s mēn.', other: 'pirms %s mēn.' },
    w: { zero: 'pirms %s ned.', one: 'pirms %s ned.', other: 'pirms %s ned.' },
    d: { zero: 'pirms %s d.', one: 'pirms %s d.', other: 'pirms %s d.' },
    h: { zero: 'pirms %s st.', one: 'pirms %s st.', other: 'pirms %s st.' },
    m: { zero: 'pirms %s min.', one: 'pirms %s min.', other: 'pirms %s min.' },
    s: { zero: 'pirms %s sek.', one: 'pirms %s sek.', other: 'pirms %s sek.' },
  },
  future: {
    y: { zero: 'pēc %s g.', one: 'pēc %s g.', other: 'pēc %s g.' },
    M: { zero: 'pēc %s mēn.', one: 'pēc %s mēn.', other: 'pēc %s mēn.' },
    w: { zero: 'pēc %s ned.', one: 'pēc %s ned.', other: 'pēc %s ned.' },
    d: { zero: 'pēc %s d.', one: 'pēc %s d.', other: 'pēc %s d.' },
    h: { zero: 'pēc %s st.', one: 'pēc %s st.', other: 'pēc %s st.' },
    m: { zero: 'pēc %s min.', one: 'pēc %s min.', other: 'pēc %s min.' },
    s: { zero: 'pēc %s sek.', one: 'pēc %s sek.', other: 'pēc %s sek.' },
  },
  abbr: {
    y: { zero: '%s g.', one: '%s g.', other: '%s g.' },
    M: { zero: '%s mēn.', one: '%s mēn.', other: '%s mēn.' },
    w: { zero: '%s ned.', one: '%s ned.', other: '%s ned.' },
    d: { zero: '%s d.', one: '%s d.', other: '%s d.' },
    h: { zero: '%s st.', one: '%s st.', other: '%s st.' },
    m: { zero: '%s min', one: '%s min', other: '%s min' },
    s: { zero: '%s sek.', one: '%s sek.', other: '%s sek.' },
  },
  justNow: 'Tikko',
  yesterday: 'Vakar',
  today: 'Šodien',
  tomorrow: 'Rīt',
  weekStart: 1,
};
const localeName: LocaleName = 'lv';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'priekšp.' : 'priekšp.';
    } else {
      return isLowerCase ? 'pēcp.' : 'pēcp.';
    }
  },
};
